import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    width: '100%',
    overflow: 'hidden',
  },
  frame: {
    display: 'block',
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: 0,
    border: 'none',
    backgroundColor: tokens.colorNeutralBackground1,
  },
});
